import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/index/main.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/star',
    name: 'star',
    component: () => import('../views/star/main.vue'),
    meta: {
      title: '明星'
    }
  },
  {
    path: '/active',
    name: 'active',
    component: () => import('../views/active/main.vue'),
    meta: {
      title: '活动'
    }
  },
  {
    path: '/topic',
    name: 'topic',
    component: () => import('../views/topic/main.vue'),
    meta: {
      title: '话题'
    },
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('../views/download/main.vue'),
    meta: {
      title: 'APP下载'
    },
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/search/main.vue'),
    meta: {
      title: '搜索页面'
    },
  },
  {
    path: '/star/detail',
    name: 'star-detail',
    component: () => import('../views/star-detail/main.vue'),
    meta: {
      title: '明星详情'
    },
  },
  {
    path: '/news/detail',
    name: 'news-detail',
    component: () => import('../views/news-detail/main.vue'),
    meta: {
      title: '资讯详情'
    },
  },
  {
    path: '/active/detail',
    name: 'active-detail',
    component: () => import('../views/active-detail/main.vue'),
    meta: {
      title: '活动详情'
    },
  },
  {
    path: '/topic/detail',
    name: 'topic-detail',
    component: () => import('../views/topic-detail/main.vue'),
    meta: {
      title: '话题详情'
    },
  },
  {
    path: '/userinfo',
    name: 'userinfo',
    component: () => import('../views/userinfo/main.vue'),
    meta: {
      title: '完善资料'
    },
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/about/main.vue'),
    meta: {
      title: '关于我们'
    },
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/contact/main.vue'),
    meta: {
      title: '联系我们'
    },
  },
  {
    path: '/serve',
    name: 'serve',
    component: () => import('../views/serve/main.vue'),
    meta: {
      title: '服务协议'
    },
  },
  {
    path: '/statement',
    name: 'statement',
    component: () => import('../views/statement/main.vue'),
    meta: {
      title: '声明'
    },
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('../views/feedback/main.vue'),
    meta: {
      title: '意见反馈'
    },
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('../views/user/main.vue'),
    meta: {
      title: '用户协议'
    },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/privacy/main.vue'),
    meta: {
      title: '隐私协议'
    },
  },
]



const router = new VueRouter({
  mode: 'history',
  // base:'/web/',
  routes
})

router.afterEach(() => {
  window.scrollTo(0,0);
})

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router
